import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IInvoiceExtraLine extends IBaseEntity {
    id?: number;
    extra: any;
    extraId: number;
    rate: number;
    discount: number;
    total: number;
    nominalCodeId?: number;
    nominalCodeDetails?: any;
}

export class InvoiceExtraLine extends BaseEntity implements IInvoiceExtraLine {
    public id?: number;
    public extra: any;
    public extraId: number;
    public rate: number;
    public discount: number;
    public total: number;
    public nominalCodeId?: number;
    public nominalCodeDetails?: any;

    constructor(invoiceExtraLine?: any) {
        super();
        if (invoiceExtraLine) {
            this.id = invoiceExtraLine.id;
            this.extra = invoiceExtraLine.extraDTO;
            this.extraId = invoiceExtraLine.extraId;
            this.rate = invoiceExtraLine.rate;
            this.discount = invoiceExtraLine.discount;
            this.total = invoiceExtraLine.total;
            this.nominalCodeId = invoiceExtraLine.nominalCodeId;
            this.nominalCodeDetails = invoiceExtraLine.nominalCodeDetails;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): InvoiceExtraLine {
        return new InvoiceExtraLine(this);
    }
}
